const openChat = () => {
  const chatButton = document?.getElementById('ecLauncherFloatingBubble');
  const isChatWindowOpen = !!document?.querySelector('.ecEmbedWrapper.dockIn');
  if (chatButton && !isChatWindowOpen) {
    chatButton.click();
  }
};

export default openChat;
